import { BaseTenantLinksDto } from '../../shared/dtos/base-tenant-links.dto';

/**
 * Vehicle damage links DTO
 */
export class VehicleDamageLinksDto extends BaseTenantLinksDto {
	rentalAgreementId?: number | null;
}
